<section class="custom-domain-add-modal">
  <div class="header">
    <div class="title">Add a domain</div>
    <div class="subtitle">Add your custom domain to create your clients’ websites with a branded URL.</div>
  </div>
  <div class="ds-input-wrap">
    <span class="ds-input-label">Domain name</span>
    <input [formControl]="domainForm" [class.error]="domainForm.invalid && domainForm.dirty" type="text"
           class="ds-input" placeholder="example.com">
    <span class="ds-input-error-msg" *ngIf="domainForm.invalid && domainForm.dirty">Please enter a valid domain</span>
  </div>
  <div class="action">
    <button class="ds-btn-black" [class.ds-btn-disabled]="domainForm.invalid" (click)="onAddDomain()"><span>Add domain</span></button>
  </div>
</section>
